import api, { ApiResponse } from './api';
import { User } from '../stores/auth.store';

interface LoginRequest {
  email: string;
  password: string;
}

interface LoginResponse {
  user: User;
  accessToken: string;
  expiresIn: number;
}

interface GoogleAuthResponse {
  authUrl: string;
}

export const authService = {
  login: async (data: LoginRequest): Promise<LoginResponse> => {
    const response = await api.post<ApiResponse<LoginResponse>>('/auth/login', data);
    return response.data.data!;
  },

  logout: async (): Promise<void> => {
    await api.post('/auth/logout');
  },

  getGoogleAuthUrl: async (): Promise<string> => {
    const response = await api.get<ApiResponse<GoogleAuthResponse>>('/auth/google');
    return response.data.data!.authUrl;
  },

  googleCallback: async (code: string): Promise<LoginResponse> => {
    const response = await api.get<ApiResponse<LoginResponse>>(
      `/auth/google/callback?code=${code}`
    );
    return response.data.data!;
  },

  requestPasswordReset: async (email: string): Promise<void> => {
    await api.post('/auth/password-reset/request', { email });
  },

  resetPassword: async (token: string, password: string): Promise<void> => {
    await api.post('/auth/password-reset', { token, password });
  },
};
